import type { FC } from 'react'

import { StackedBar, barColors, disabledBarColor } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { LOCATION_TYPES } from 'modules/attendance/store/models/Shift'
import { TeamsShiftLocation } from 'modules/teams/store/collections/teamsShiftLocation'

interface Props {
  id: string
  teamsShiftsLoading?: boolean
  shiftLocations: TeamsShiftLocation
}

const WorkLocationStackedBar: FC<Props> = ({ id, shiftLocations, teamsShiftsLoading }) => {
  const locationType = shiftLocations.models.find((location) => location.attributes.id === id)

  const results = locationType?.attributes.location_type.results
  const error = results?.length === 0 && !!locationType?.attributes.location_type.error

  const locationTypeBars = results
    ?.slice()
    ?.sort((a, b) =>
      !!a.id && !!b.id ? a.id.localeCompare(b.id, undefined, { numeric: true }) : -1
    )
    .map((x, i) => {
      const { label, value } = x
      const percentage = Math.floor(value * 100)
      const [workFromHome, office, businessTrip, ...otherColors] = barColors
      let color
      let textLabel = i18n.t(`teams.working_location_types.not_defined`)

      switch (label) {
        case LOCATION_TYPES.WORK_FROM_HOME:
          color = workFromHome
          textLabel = i18n.t(`teams.working_location_types.work_from_home`)
          break
        case LOCATION_TYPES.OFFICE:
          color = office
          textLabel = i18n.t(`teams.working_location_types.office`)
          break
        case LOCATION_TYPES.BUSINESS_TRIP:
          color = businessTrip
          textLabel = i18n.t(`teams.working_location_types.business_trip`)
          break
        default:
          color = otherColors[i]
      }
      return teamsShiftsLoading ? (
        <></>
      ) : (
        <StackedBar.Bar
          key={label}
          value={percentage}
          label={`${textLabel} ${percentage}%`}
          color={color}
        />
      )
    })

  return (
    <StackedBar>
      {error ? (
        <StackedBar.Bar
          value={100}
          color={disabledBarColor}
          label={locationType?.attributes.location_type.error?.message}
        />
      ) : (
        locationTypeBars
      )}
    </StackedBar>
  )
}

export default observer(WorkLocationStackedBar)
